module.exports = __webpack_public_path__ + "static/media/tornado.f6da188c.svg";